import { z } from "zod";
import { zString } from "../../../config/schemas/commonSchemaObjects";
export const assignComponentSchema = z.object({
  components: z.array(zString.zRequired),
  medium_screen_size: z
    .union([
      z
        .number({ invalid_type_error: "Required" })
        .min(1, "Minimum value is 1")
        .max(12, "Maximum value is 12"),
      z.null(),
    ])
    .nullable()
    .refine((value) => value === null || value >= 0, {
      message: "Minimum value is 1",
    }),
  small_screen_size: z
    .union([
      z
        .number({ invalid_type_error: "Required" })
        .min(1, "Minimum value is 1")
        .max(12, "Maximum value is 12"),
      z.null(),
    ])
    .nullable(),
});

export const addComponentSchema = z.object({
  component_name: zString.zRequired,
  selected_entity: zString.zRequired,
});

export const detailsAddComponentSchema = z.object({
  component_name: zString.zRequired,
  selected_entity: zString.zRequired,
  component_type: zString.zRequired,
});
